import React from 'react';
import { TextButton } from '@oneaudi/unified-web-components';
import { useTrackingManager } from '../useTrackingManager';
import type { CtaButtonProps } from './CtaBar';
import { getCtaLabel } from '../../lib/ctaLabel';

export type CtaUrlButtonProps = CtaButtonProps & {
  url: string;
  target?: '_self' | '_blank';
};

export const CtaUrlButton = ({
  variant,
  url,
  label,
  displayname,
  position,
  target = '_self',
}: CtaUrlButtonProps): React.ReactElement => {
  const trackingManager = useTrackingManager();
  return (
    <TextButton
      variant={variant}
      href={url}
      target={target}
      rel={target === '_blank' ? 'noopener noreferrer' : undefined}
      onClick={() => {
        trackingManager.click('exit_link', url, 'cta', label, displayname, position, label);
      }}
      size="sm"
    >
      {getCtaLabel(label)}
    </TextButton>
  );
};
